import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography, Box } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Image } from '../index';
import styles from './styles';
export const EmptyInbox = () => {
    const { t: text } = useTranslation();
    return (_jsx(Box, { sx: styles.emptyInbox, children: _jsxs(Box, { sx: styles.centerImage, children: [_jsx(Image, { src: '/assets/images/no-insights.svg' }), _jsx(Typography, { variant: 'body1', sx: { mt: 1 }, children: text('NO_INSIGHTS_TEXT') })] }) }));
};
